module.exports = require("./pt-GQ.js");